import { Point } from "../../models";

export const tableCardsContainerPosition: Point = { x: 0, y: 1129 };

export const communityCardPositions: Point[] = [
  { x: 236, y: 41 },
  { x: 359, y: 41 },
  { x: 482, y: 41 }, // middle card
  { x: 605, y: 41 },
  { x: 728, y: 41 },
];
export const communityCardScale: Point = { x: 1.35, y: 1.161 };
export const r2tT1Positions: Point[] = [
  { x: 299.1, y: 9.1 },
  { x: 400.0, y: 9.1 },
  { x: 495.8, y: 9.1 },
  { x: 591.6, y: 9.1 },
  { x: 692.5, y: 9.1 },
];
export const r2tT2Positions: Point[] = [
  { x: 281.4, y: 128.9 },
  { x: 386.8, y: 128.9 },
  { x: 492.3, y: 128.9 },
  { x: 597.7, y: 128.9 },
  { x: 703.2, y: 128.9 },
];
export const r2tT1Scale: Point = { x: 1.0274, y: 0.8836 };
export const r2tT2Scale: Point = { x: 1.11, y: 0.9546 };
// Shared R2T cards stay exactly where the single board put them
export const r2tSharedPositions: Point[] = communityCardPositions.slice(0, 4);
export const r2tSharedScale: Point = communityCardScale;
export const r2tPartialScale: Point = { x: 1.242, y: 1.0681 };
export const r2tPartialLayouts: { [sharedCards: number]: { t1: Point[]; t2: Point[] } } = {
  3: {
    t1: [{ x: 599.3, y: -23.0 }, { x: 710.4, y: -23.0 }],
    t2: [{ x: 609.8, y: 116.3 }, { x: 725.8, y: 116.3 }],
  },
  4: {
    t1: [{ x: 719.7, y: -23.0 }],
    t2: [{ x: 735.1, y: 116.3 }],
  },
};
export const communityCardEdgeTilt: number[] = [0.1222, 0.0977, 0.0524, -0.0524, -0.0977, -0.1222];
